import PorWidget from "../PorWidget";

const ASSURANCES = [
  {
    title: "Live Oracle Revaluation",
    body: "Declared audited inventory is repriced against the sovereign oracle matrix on every pull — no static snapshots.",
  },
  {
    title: "Chain-Attested",
    body: "Each feed cross-checks Genesis Node 9940 for the engine vault balance and block height before sealing.",
  },
  {
    title: "Zero Trailing Usury",
    body: "Every figure settles T+0. No compounding tails, no hypothecation, no T+3 liquidation window.",
  },
];

const ProofOfReserve = () => {
  return (
    <section
      id="proof-of-reserve"
      data-testid="por-section"
      className="py-28 px-6 border-b border-stone-800 bg-gradient-to-b from-stone-950 to-[#0a1128]"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-7 space-y-8">
          <div className="space-y-4">
            <span className="mono-tag text-xs uppercase tracking-widest text-amber-500">
              Live Proof of Reserve
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-stone-100 display-serif">
              The Reserve Never Leaves the Vault
            </h2>
            <p className="text-base text-stone-300 leading-relaxed max-w-xl">
              Unlike public institutions that slice, tranche, and liquidate debt inside a fixed
              T+3 window, the BOURG MERCHANT EXCHANGE (BMEX) — the Institute&rsquo;s 501(c)(2)
              privatized, non-marketable exchange — holds its physical underlying permanently.
              This feed values the declared audited inventory — Tier-1 specie and Zone 9b
              agroforestry pools — against live sovereign oracle rates and cross-attests every
              figure against the private chain, sealed with a cryptographic root hash recomputed
              on every pull.
            </p>
          </div>
          <div className="space-y-5">
            {ASSURANCES.map((item) => (
              <div key={item.title} className="flex gap-4 items-start">
                <span className="mt-1.5 w-2 h-2 rounded-full bg-amber-500 pulse-glow shrink-0"></span>
                <div>
                  <p className="text-sm font-bold text-stone-100">{item.title}</p>
                  <p className="text-sm text-stone-400 leading-relaxed">{item.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-5 flex justify-center lg:justify-end">
          <PorWidget />
        </div>
      </div>
    </section>
  );
};

export default ProofOfReserve;
